import React, { Component } from 'react';
import Dashboard from "views/Dashboard/Dashboard.jsx";
import Asm from "views/AsmReport/Asm.jsx";
import Msdsales from 'views/MDCReport/Msdsales';
import StoreReport from 'views/storeReport/StoreReport';
import Tables from "views/Dashboard/Abstract.js";
import DetailView from "views/Dashboard/Detailview.js";
import ModulationReport from "views/Dashboard/ModelEvalutionReport.js";
import CombinedView from 'views/Dashboard/EvaluationDetails';
import ExecutiveCount from 'views/Dashboard/ExceutiveCount';
import StoreReportDashboard from 'views/Dashboard/StoreReportDashboard';
import ActiveProductScreen from 'views/Dashboard/ActiveProductScreen';
import VisibilityItemsView from 'views/Dashboard/VisibilityItems';
import SourceDataUpdate from 'views/Dashboard/EvaluationSource';
import ModulationDetailView from 'views/Dashboard/ModulationDetailView';
import ModelComparisonView from 'views/Dashboard/ModelComparison';
import SignIn from "views/Pages/SignIn.js";
import REDScoreReport from 'views/Dashboard/RedScore';
import DownloadExcel from 'views/downloadExcel/DownloadExcel.jsx';
import Admin from 'views/Pages/Admin.js';
import VisiCoolerImageReport from 'views/VisiCoolerImageReport/visiCoolerImageReport';
import {
  HomeIcon,
  StatsIcon,
  DocumentIcon,
  RocketIcon,
  InventoryIcon,
  AbstractReportIcon,
  DetailReportIcon,
  AccountIcon,
  ModelTestIcon,
  ReportIcon,
  DetailViewIcon,
  CountIcon,
  SourceUpdateIcon,
  ComparisonIcon,
  PersonIcon,
  ClockIcon,
  DownloadIcon,
} from "components/Icons/Icons";
import RedAllocationSheet from 'views/RedAllocation/RedAllocationSheet';
import ModalResults from 'views/ModalResults/ModalResults';
import RedFreshness from 'views/RedFreshness/RedFreshness';
import RoleBasedAccess from 'views/RoleBasedAccess/RoleBasedAccess';
import StoreAbstract from 'views/StoreAbstract/StoreAbstract';
import DisReport from 'views/disReport/DisReport';
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <HomeIcon color='inherit' />,
    component: Dashboard,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],
  },
  // {
  //   path: "/ExecutiveCount",
  //   name: "Executive Count",
  //   icon: <CountIcon color='inherit' />,
  //   component: ExecutiveCount,
  //   layout: "/admin",
  // },
  // {
  //   path: "/StoreReport",
  //   name: "Store Report",
  //   icon: <InventoryIcon color='inherit' />,
  //   component: StoreReportDashboard,
  //   layout: "/admin",
  // },
  {
    path: "/Asm",
    name: "ASM Report",
    icon: <PersonIcon color='inherit' />,
    component: Asm,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],

  },
  {
    path: "/MDC",
    name: "MDC Report",
    icon: <ReportIcon color='inherit' />,
    component: Msdsales,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],

  },
  {
    path: "/Softdrink",
    name: "Store Report",
    icon: <ClockIcon color='inherit' />,
    component: StoreReport,
    layout: "/admin",
    roles: ["ORGIUSER","ITUSER"],
  },
  
  {
    path: "/ReportCenter",
    name: "Report Center",
    icon: <StatsIcon color='inherit' />,
    component: DownloadExcel,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],
  },
  {
    path: "/visicoolerImage",
    name: "Visicooler Image Report",
    icon: <SourceUpdateIcon color='inherit' />,
    component: VisiCoolerImageReport,
    layout: "/admin",
    roles: ["ITUSER", "CocaColaUSER"],
  },
  {
    path: "/redAllocaion",
    name: "Red Allocation ",
    icon: <ComparisonIcon color='inherit' />,
    component: RedAllocationSheet,
    layout: "/admin",
    roles: ["ITUSER"],
  },
  {
    path: "/redFreshness",
    name: " Red Freshness",
    icon: <DetailViewIcon color='inherit' />,
    component: RedFreshness,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],
  },

  {
    path: "/modelResults",
    name: " Model Results",
    icon: <RocketIcon color='inherit' />,
    component: ModalResults,
    layout: "/admin",
    roles: ["ITUSER"]
  },
  {
    path: "/storeAbstract",
    name: "Store Abstract",
    icon: <InventoryIcon color='inherit' />,
    component: StoreAbstract,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],
  },
  {
    path:"/disReport",
    name:"Dis Report",
    icon:<ReportIcon color='inherit' />,
    component:DisReport,
    layout: "/admin",
    roles:["ITUSER", "ORGIUSER"],
  },
  {
    name: "Download Center",
    icon: <DownloadIcon color='inherit' />,
    isExternal: true,
    externalUrl: "https://605-downloader-ui.vercel.app/",
    roles: ["ITUSER", "ORGIUSER"],
  },
  {
    path: "/role-based-access",
    name: "Role Based Access",
    icon: <DownloadIcon color='inherit' />,
    component: RoleBasedAccess,
    layout: "/admin",
    roles: ["ITUSER", "ORGIUSER"],
  },
 
  // {
  //   path: "/StoresAuditing",
  //   name: " Store Auditing",
  //   icon: <InventoryIcon color='inherit' />,
  //   component: StoreAuditing,
  //   layout: "/admin"

  // },
  // {
  //   path: "/RedScore",
  //   name: "Red Score Report",
  //   icon: <InventoryIcon color='inherit' />,
  //   component: REDScoreReport,
  //   layout: "/admin",
  // },
  {
    name: "Inventory",
    category: "inventory",
    state: "inventoryCollapse",
    icon: <InventoryIcon color='inherit' />,
    views: [
      {
        path: "/abstract",
        name: "Abstract Report",
        icon: <AbstractReportIcon color='inherit' />,
        component: Tables,
        layout: "/admin",
      },
      {
        path: "/detail",
        name: "Detail Report",
        icon: <DetailReportIcon color='inherit' />,
        component: DetailView,
        layout: "/admin",
      },
      {
        path: "/VisibilityItems",
        name: "Visibility Items",
        icon: <StatsIcon color='inherit' />,
        component: VisibilityItemsView,
        layout: "/admin",
      }
    ],
  },
  // {
  //   name: "Model Testing",
  //   category: "evaluation",
  //   state: "evaluationCollapse",
  //   icon: <ModelTestIcon color='inherit' />,
  //   views: [
  //     {
  //       path: "/ModulationReport",
  //       name: "Report",
  //       icon: <ReportIcon color='inherit' />,
  //       component: ModulationReport,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/ModulationDetailView",
  //       name: "DetailView",
  //       icon: <DetailViewIcon color='inherit' />,
  //       component: ModulationDetailView,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/EvaluationCount",
  //       name: "Count",
  //       icon: <CountIcon color='inherit' />,
  //       component: CombinedView,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/SourceUpdate",
  //       name: "Source Update",
  //       icon: <SourceUpdateIcon color='inherit' />,
  //       component: SourceDataUpdate,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/ModelComparison",
  //       name: "Comparison",
  //       icon: <ComparisonIcon color='inherit' />,
  //       component: ModelComparisonView,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/ProductsScreen",
  //       name: "Active Products",
  //       icon: <ComparisonIcon color='inherit' />,
  //       component: ActiveProductScreen,
  //       layout: "/admin",
  //     },
  //   ],
  // },

  {
    name: "Account",
    category: "account",
    state: "pageCollapse",
    icon: <RocketIcon color='inherit' />,
    views: [
      {
        path: "/signin",
        name: "Sign In",
        icon: <DocumentIcon color='inherit' />,
        component: SignIn,
        layout: "/auth",
      },
    ],
  },
  // {
  //   path: "/add-user",
  //   name: "Admin",
  //   icon: <PersonIcon color='inherit' />,
  //   component: Admin,
  //   layout: "/admin",
  // }

];
export default dashRoutes;